import axios from 'axios';
import AlertServie from './errors.service';
import router from '@/router';

const ErrorHandlerService = {
  init() {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response ? error.response.status : null;
        const data = error?.response?.data ?? {};
        const serverMessage =
          data?.message ||
          data?.error ||
          (typeof data === 'string' ? data : '') ||
          (typeof data?.detail === 'string' ? data.detail : '');

        if (status === 401) {
          localStorage.removeItem('loggedIn');
          localStorage.removeItem('access_token');
          localStorage.removeItem('user');
          localStorage.removeItem('permissions');
          localStorage.removeItem('role');
          router.push('/login');
          if (serverMessage) AlertServie.errorMessage(serverMessage);
        } else if (status == 422) {
          const errors = data?.errors;
          if (errors && typeof errors === 'object') {
            try {
              for (const value of Object.values(errors)) {
                const msg = Array.isArray(value) ? value[0] : value;
                if (msg) AlertServie.errorMessage(String(msg));
              }
            } catch (e) {
              if (serverMessage) AlertServie.errorMessage(serverMessage);
            }
          } else if (serverMessage) {
            AlertServie.errorMessage(serverMessage);
          }
        } else if (status == 500 || status == 429) {
          router.push({ name: '500' });
        } else if (status == 403) {
          if (serverMessage) AlertServie.errorMessage(serverMessage);
        } else if (status == 404) {
          router.push({ name: '404' });
        } else if (status == 400) {
          router.push({ name: '400' });
          if (serverMessage) AlertServie.errorMessage(serverMessage);
        } else if (status === 402) {
          router.push({ name: 'expirePlan' });
        } else if (status === 423) {
          router.push({ name: 'Inactive' });
        }
        return Promise.reject(error);
      }
    );
  }
};

export default ErrorHandlerService;
